import { Dialog } from "@mui/material";
import {
  defValueCategoriaComercial,
  TCategoria,
} from "../../../../../../types/api/comercial/categorias";
import DialogContentSelectGeneric from "../../../../../../components/SelectsSimpleApiQuery/DialogsContents/DialogContentGeneric";

export default function DialogSubcategorias({
  open,
  handleClose,
  value,
  onChange,
  categoriaId,
  breadcrumb = false,
}: DialogSubcategoriasProps) {
  return (
    <Dialog fullWidth maxWidth={breadcrumb ? "md" : "sm"} open={open} onClose={handleClose}>
      <DialogContentSelectGeneric
        {...{ handleClose }}
        multiple
        title="Selecionar categoria"
        queryPath={`/comercial/configuracoes/pesquisar-categorias?categoriaId=${categoriaId}&`}
        getItemKey={(item) => item.id}
        defaultValue={
          Array.isArray(value) && value.length > 0
            ? value
            : [defValueCategoriaComercial]
        }
        getItemLabel={(item) => `${item.nome}`}
        onChange={(value) => {
          onChange(value as TCategoria[]);
          handleClose();
        }}
        extraParams={{ breadcrumb }}
      />
    </Dialog>
  );
}

interface DialogSubcategoriasProps {
  open: boolean;
  handleClose: () => void;
  value: TCategoria[];
  onChange: (arg: TCategoria[] | null) => void;
  categoriaId: number | null;
  breadcrumb?: boolean;
}
